import { deleteAllCookies } from "../../utilities/cookiesUtil";

export const initialState = {
  isLoggedIn: JSON.parse(localStorage.getItem("isLoggedIn")) || false,
  user: JSON.parse(localStorage.getItem("user")) || null
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      localStorage.setItem(
        "isLoggedIn",
        JSON.stringify(action.payload.isLoggedIn)
      );
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      // to do use jwt instead of accessTOken
      document.cookie = `accessToken=${action.payload.user.accessToken}`;
      document.cookie = `refreshTokenJWT=${action.payload.user.refreshTokenJWT}`;
      document.cookie = `jwtExpires=${action.payload.user.jwtExpires}`;
      document.cookie = `refreshExpires=${action.payload.user.refreshExpires}`;
      return {
        ...state,
        isLoggedIn: action.payload.isLoggedIn,
        user: action.payload.user
      };
    }
    case "LOGOUT": {
      localStorage.clear();
      deleteAllCookies();
      return {
        ...state,
        isLoggedIn: false,
        user: null
      };
    }
    default:
      return state;
  }
};
